<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M6.3341 0C5.90367 0 5.52153 0.275429 5.38542 0.683771L3.05208 7.68377C2.83624 8.3313 3.31821 9 4.00077 9H5.54565C5.86552 9 6.10313 9.29621 6.03374 9.60846L4.77288 15.2823C4.69104 15.6506 4.97129 16 5.34857 16C5.51702 16 5.67743 15.928 5.78934 15.8021L12.134 8.66436C12.7072 8.01946 12.2494 7 11.3866 7H10.2716C9.90978 7 9.66775 6.62757 9.81471 6.29693L11.9884 1.40614C12.2823 0.744851 11.7982 0 11.0746 0H6.3341Z"
    fill="#C2C6CD"
  />
</template>
